import React from "react"

const BandMember = ({ title, members }) => (
  <>
    <div className="">
      {members.map(({ name, blurb, instruments, photo, ref }, index) => {
        return (
          <div>
            <div className="bio" id={ref}>
              <img src={photo} className="leftphoto photo" alt="" />
              <div className="info">
                <div className="name">{name}</div>
                <div className="name, instruments">{instruments}</div>
                <div className="blurb">
                  {blurb.map((item) => {
                    return <p>{item}</p>
                  })}
                </div>
              </div>
              <img src={photo} className="rightphoto photo" alt="" />
            </div>
          </div>
        )
      })}
    </div>
  </>
)

export default BandMember
